export default function scenarioTypeStatus(
  pathname: string,
  scenarioType: string,
  cfg: Remind.Config,
) {
  // 跟单助手/弃单挽回
  if (pathname.startsWith('/aide/saveOrder/')) {
    if (!cfg?.orderAbandonGroup?.enable) {
      return false;
    }

    const sceneCfg = cfg?.orderAbandonGroup?.remindScene;
    {
      const types = {
        RETURN_REFUND_ITEM_MISSING: 'returnRefundItemMissing',
        RETURN_REFUND_WRONG_ITEM: 'returnRefundWrongItem',
        RETURN_REFUND_PHYSICAL_DMG: 'returnRefundPhysicalDmg',
        RETURN_REFUND_FUNCTIONAL_DMG: 'returnRefundFunctionalDmg',
      };
      // @ts-ignore
      if (Object.keys(types).includes(scenarioType)) {
        const sCfg = sceneCfg?.RETURN_REFUND_RETRIEVE?.returnRefundRetrieveConfig || {};
        // @ts-ignore
        return !!sCfg?.[types[scenarioType]];
      }
    }

    {
      const types = {
        ONLY_REFUND_NOT_RECEIPT: 'onlyRefundNotReceipt',
        ONLY_REFUND_ITEM_MISSING: 'onlyRefundItemMissing',
        ONLY_REFUND_WRONG_ITEM: 'onlyRefundWrongItem',
        ONLY_REFUND_PHYSICAL_DMG: 'onlyRefundPhysicalDmg',
        ONLY_REFUND_FUNCTIONAL_DMG: 'onlyRefundFunctionalDmg',
      };
      // @ts-ignore
      if (Object.keys(types).includes(scenarioType)) {
        const sCfg = sceneCfg?.REFUND_RETRIEVE?.refundRetrieveConfig || {};
        // @ts-ignore
        return !!sCfg?.[types[scenarioType]];
      }
    }

    {
      const types = {
        CANCELLING_TRADE_CHANGE_ADDRESS: 'cancellingTradeChangeAddress',
        CANCELLING_TRADE_MODIFY_ORDER: 'cancellingTradeModifyOrder',
        CANCELLING_TRADE_OTHERS: 'cancellingTradeOthers',
        CANCELLING_TRADE_IRRESPONDING: 'cancellingTradeIrresponding',
        CANCELLED_TRADE_CHANGE_VOUCHER: 'cancelledTradeChangeVoucher',
        CANCELLED_TRADE_MODIFY_ORDER: 'cancelledTradeModifyOrder',
        CANCELLED_TRADE_CHANGE_MIND: 'cancelledTradeChangeMind',
        CANCELLED_TRADE_FOUND_CHEAPER: 'cancelledTradeFoundCheaper',
        CANCELLED_TRADE_TOO_TROUBLESOME: 'cancelledTradeTooTroublesome',
        CANCELLED_TRADE_OTHERS: 'cancelledTradeOthers',
      };
      // @ts-ignore
      if (Object.keys(types).includes(scenarioType)) {
        const sCfg = sceneCfg?.CANCEL_ORDER_RETRIEVE?.cancelOrderRetrieveConfig || {};
        // @ts-ignore
        return !!sCfg?.[types[scenarioType]];
      }
    }
  }
  // 跟单助手/评价管理/中差评挽回
  else if (pathname === '/aide/review/review/NEGATIVE_REVIEW_SAVE') {
    return !!cfg?.reviewGroup?.enable;
  }

  return false;
}
